<template lang="pug">
.tabbed-view(slot-scope="x")
    .tabs
        a(
            @click="setIndex($event, 0)",
            :class="{ active: index == 0 }",
            data-cursor-shrink
        ) Technical Skills
        a(
            @click="setIndex($event, 1)",
            :class="{ active: index == 1 }",
            data-cursor-shrink
        ) Design Skills
        a(
            @click="setIndex($event, 2)",
            :class="{ active: index == 2 }",
            data-cursor-shrink
        ) Interests &amp; hobbies
        a(
            @click="setIndex($event, 3)",
            :class="{ active: index == 3 }",
            data-cursor-shrink
        ) Project Role
    .tabbed-view-container(ref="content")
        slot
        //- .tabbed-content(v-show="index == 0")
        //-     slot(name="tab1")
        //- .tabbed-content(v-show="index == 1")
        //-     slot(name="tab2")
        //- .tabbed-content(v-show="index == 2")
        //-     slot(name="tab3")
        //- .tabbed-content(v-show="index == 3")
        //-     slot(name="tab4")
</template>

<script>
export default {
    name: "tabbed-information",
    data() {
        return {
            index: 0,
            contentItems: null,
            animationDelay: 100, // in ms
        };
    },
    mounted() {
        this.contentItems = this.$refs.content.querySelectorAll(
            ".tabbed-content"
        );
        this.renderTabContent();
        this.bindAnimations();
    },
    methods: {
        setIndex(e, index) {
            e.preventDefault();
            this.index = index;
            this.renderTabContent();
        },
        renderTabContent() {
            this.contentItems.forEach((element) => {
                let id = parseInt(element.getAttribute("data-id"));
                if (id != this.index) {
                    element.classList.remove("visible");
                } else element.classList.add("visible");
            });
        },
        bindAnimations() {
            this.contentItems.forEach((element) => {
                let delay = 0;
                element.querySelectorAll(".skill-list").forEach((list) => {
                    list.querySelectorAll("li:not(.hidden)").forEach(
                        (listitem) => {
                            listitem.style.animationDelay = `${delay}ms`;
                            delay += this.animationDelay;
                        }
                    );
                });
            });
        },
    },
};
</script>

<style lang="scss">
.tabbed-view {
    font-size: 1.8rem;
    .tabs {
        display: flex;
        flex-flow: row wrap;
        align-items: center;

        padding-bottom: calc(0.6em - 1px);
        a {
            transition: color 150ms ease-in-out;
            display: inline-block;
            position: relative;
            color: transparentize($cl-grey, 0.5);
            font-weight: 600;
            cursor: pointer;

            &:not(:last-child) {
                margin-right: 2em;
            }

            &::after {
                content: "";
                width: 0;
                height: 1px;
                left: 0;
                bottom: -0.6em;
                position: absolute;
                background-color: $cl-red;
                transition: width 150ms ease-in-out;
            }
        }
        .active {
            color: $cl-red;
            &::after {
                width: 5rem;
            }
        }

        @include respond-below(lg) {
            justify-content: space-between;
            align-items: flex-start;
            a {
                flex-basis: 40%;
                margin-right: 0 !important;
                margin-bottom: 0.8rem;

                &::after {
                    display: none;
                }
            }
        }
    }

    .tabbed-view-container {
        margin-top: 2.4rem;
    }

    .tabbed-content {
        display: none;
        &.visible {
            display: block;
        }
    }
}
</style>